import throttle from "./throttle"

export default function registerDirectives(app) {
 app.directive("throttle", throttle)
}


// WEBPACK FOOTER //
// ./src/directives/index.js